const schema = {
  turboPermanentAttribute: 'data-turbo-permanent'
}

export default { ...schema }
